var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconScissors = function SvgIconScissors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 10.75a3.6 3.6 0 0 0 2.312-.832L10.98 12l-3.043 2.082a3.625 3.625 0 1 0 1.13 1.65l3.683-2.52 8.436 5.773a1 1 0 0 0 1.13-1.65l-8.977-6.144-.047-.032-4.226-2.892a3.625 3.625 0 1 0-3.441 2.483m0-5.25a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25m0 9.75a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.315 6.666a1 1 0 0 0-1.13-1.65l-5.682 3.89a1 1 0 0 0 1.13 1.65z"
  }))));
};
export default SvgIconScissors;